/**
 * @file Automatically generated by barrelsby.
 */

export * from './mat-input.component';
export * from './mat-input.model';
